module.exports = "/_next/static/resources/art-c679e923c100e59babf58dd866000492.webp";